import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useTenantSettings } from '@/hooks/useTenantSettings';

export type TenantModule = 'inspections' | 'serviceBook' | 'partsOrdering';

/**
 * Direct-URL guard for a tenant module (#2646). Permissions are applied by
 * the surrounding `PermissionRoute`; this only hides a module the workshop
 * has switched off. While `/tenants/me` is still loading, the page stays
 * mounted so an enabled tenant does not flash a redirect.
 */
export function TenantModuleRoute({
  module,
  children,
}: {
  module: TenantModule;
  children: ReactNode;
}) {
  const { isFetched, inspectionsEnabled, serviceBookEnabled, partsOrderingEnabled } =
    useTenantSettings();

  const enabled =
    module === 'inspections'
      ? inspectionsEnabled
      : module === 'serviceBook'
        ? serviceBookEnabled
        : partsOrderingEnabled;

  if (isFetched && !enabled) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
